import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Adal8Service } from 'adal-angular8';
import { interval } from 'rxjs';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { Login } from '../../../observation/model/login.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { AuthenticationService } from '../../services/authentication.service';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';
import { ConstantsService } from './../../services/constants.service';
import { GlobalConstants } from './../../services/GlobalConstants.service';
import moment from 'moment';

@Component({
  selector: 'ara-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  HomePageImagePath =GlobalConstants.HomePageImagePath;
  
  loggedInUserJSON: any;
  loginDate: Date = new Date();
  userloginid: number;
  IpAddress: string;
  isAppAdmin: boolean = false;
  isValidUser: boolean;
  permissions: any = [];
  isOnline: boolean = false;
  login: Login;
  units: any;
  loggedinUserType:string;
  EmployeeType : string = "Emp";
  unitsProcessed: number;
  FromDate: Date =new Date( new Date().setHours(12, 12, 12, 0));
  ToDate: Date =new Date( new Date().setHours(12, 12, 12, 0));
  FromDateForUser: Date =new Date( new Date().setHours(12, 12, 12, 0));
  ToDateForUser: Date =new Date( new Date().setHours(12, 12, 12, 0));
  LoggedInUsers : string = "";
  ObservationCount : string = "";
  IncidentCount : string = "";
  InspectionCount : string = "";
  RiskCount  : string = "";
  POBCount : string = "";
  ActionCount : string = "";
  PermitCount : string = "";
  TNCPending : string = "";
  PTWPending : string = "";
  ActionPending : string = "";
  RiskPending : string = "";
  LastPermitDate : string = "";
  ActionsTaken : string = "";
  TrainingApproved : string = "";
  LastActivityDate : string = "";
  Employees : string = "";
  Contractors : string = "";
  ObservationCountForUser : string = "";
  IncidentCountForUser : string = "";
  InspectionCountForUser : string = "";
  PermitCountForUser : string = "";
  RiskCountForUser : string = "";
  ActionCountForUser : string = "";
  TNCPendingForUser : string = "";
  PTWPendingForUser : string = "";
  ActionPendingForUser : string = "";
  RiskPendingForUser : string = "";
  SelectedData : any;
  constructor(private baseService: BaseService,
    private adal4Service: Adal8Service,
    private commonService: CommonService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private masterscreenService: MasterscreenService,
    private observationService: ObservationService) {

  }

  ngOnInit() {
    this.checkOnlineStatus();
    this.authenticationService.fetchIPInfo();
    if (this.adal4Service && this.adal4Service.userInfo) {
      this.baseService.showRootLoader = false;
      this.baseService.reportRoutes = [];
      this.baseService.routesFlag = [];
      this.setUserDetails();
    }

     this.loggedinUserType = this.baseService.getItemFromSession(ConstantsService.LoggedInUserType);
    if (this.loggedinUserType === ConstantsService.authenticationType.Contractor) {
      this.setUserDetails();
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    if (navigator.onLine) {
      const apiRequestUnit = {
        Model: {
          ModuleId: 4,
          UserId: this.loggedInUserJSON.UserId
        }
      }
      this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));
      
    }
    this.GetDashboardCount(0);
   
  }

  GetDashboardCount(called)
  {
    const filter = JSON.parse(this.baseService.getFilterData('dashboardFilter'));
    if(called == 0 && filter)
    {
      this.FromDate = new Date(filter.Model.FromDateForOverview);
      this.ToDate = new Date(filter.Model.ToDateForOverview);
      this.FromDateForUser = new Date(filter.Model.FromDateForUser);
      this.ToDateForUser = new Date(filter.Model.ToDateForUser);
    }
    if (this.loggedinUserType === ConstantsService.authenticationType.Employee) 
    {
    //   const permissionsFromSession = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    //   if (permissionsFromSession) {
    //     this.permissions = permissionsFromSession;
    //   }  
    // this.EmployeeType = "Emp";  
    // if (this.permissions.SUPER_Admin || this.permissions.APP_Admin || this.permissions.HSE_Admin)
    // {
    //   this.EmployeeType = "Admin";
    // } 
    const apiRequestDashboard = {
      Model: {
        FromDateForOverview: this.FromDate ? new Date( this.FromDate.setHours(0, 0, 0, 0)) : new Date( new Date().setHours(0, 0, 0, 0)),
        ToDateForOverview : this.ToDate ? new Date( this.ToDate.setHours(23, 59, 59, 0)) : new Date( new Date().setHours(23, 59, 59, 0)),
        FromDateForUser: this.FromDateForUser ? new Date( this.FromDateForUser.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        ToDateForUser : this.ToDateForUser ? new Date( this.ToDateForUser.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        UserId: this.loggedInUserJSON.UserId,
        EmployeeType : this.EmployeeType
      }
    }

    this.baseService.setFilterData('dashboardFilter', JSON.stringify(apiRequestDashboard));

    this.masterscreenService.getCountForDashboard(apiRequestDashboard, this.callbackMethodForgetCountForDashboard.bind(this))
    } 
  }

  callbackMethodForgetCountForDashboard(response) {
  
    if(response && response.Success)
    {
      const result = response.Result;

      this.LoggedInUsers = result.LoggedInUsers;
      this.Employees = result.Employees;
      this.Contractors = result.Contractors;

      this.ObservationCount = result.ObservationCount;
      this.IncidentCount = result.IncidentCount;
      this.InspectionCount = result.InspectionCount;
      this.RiskCount = result.RiskCount;
      this.POBCount = result.POBCount;
      this.ActionCount = result.ActionCount;
      this.PermitCount = result.PermitCount;

      this.TNCPending = result.TNCPending;
      this.PTWPending = result.PTWPending;
      this.ActionPending = result.ActionPending;
      this.RiskPending = result.RiskPending;
      
      this.ObservationCountForUser = result.ObservationCountForUser;
      this.IncidentCountForUser = result.IncidentCountForUser;
      this.InspectionCountForUser = result.InspectionCountForUser;
      this.PermitCountForUser = result.PermitCountForUser;
      this.RiskCountForUser = result.RiskCountForUser;
      this.ActionCountForUser = result.ActionCountForUser;

      this.TNCPendingForUser = result.TNCPendingForUser;
      this.PTWPendingForUser = result.PTWPendingForUser;
      this.ActionPendingForUser = result.ActionPendingForUser;
      this.RiskPendingForUser = result.RiskPendingForUser;

    }

  }

  GetDashboardSelectedDetails(Type,Module){

    const apiRequestDashboard = {
      Model: {
        FromDateForOverview: this.FromDate ? new Date( this.FromDate.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        ToDateForOverview : this.ToDate ? new Date( this.ToDate.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        FromDateForUser: this.FromDateForUser ? new Date( this.FromDateForUser.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        ToDateForUser : this.ToDateForUser ? new Date( this.ToDateForUser.setHours(12, 12, 12, 0)) : new Date( new Date().setHours(12, 12, 12, 0)),
        UserId: this.loggedInUserJSON.UserId,
        EmployeeType : this.EmployeeType,
        Type : Type,
        Module : Module
      }
    }
    this.masterscreenService.getDashboardSelectedDetails(apiRequestDashboard, this.callbackMethodForGetDashboardSelectedDetails.bind(this))
  }

  callbackMethodForGetDashboardSelectedDetails(response)
  {
    if(response && response.Success)
    this.SelectedData = response.Result;
  }

  Redirect(Value,Id,Module)
  {
    if(Module == "Obs")
    {
      window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+Value+';unitId='+Id], '_self');
    }
    else if(Module == "Inc")
    {
      window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+Value], '_self');
    }
    else if(Module == "Ins")
    {
      window.open(ConstantsService.URL.APP + ['/inspection/add-inspection/'+Value], '_self');
    }
    else if(Module == "Permit")
    {
      window.open(ConstantsService.URL.APP + ['/ptw/raise-permit/'+Value+';unitId='+Id], '_self');
    }
    else if(Module == "Risk")
    {
      window.open(ConstantsService.URL.APP + ['/risk/raise-risk-' + Id +'/'+Value], '_self');
    }
    else if(Module == "Action")
    {
      window.open(ConstantsService.URL.APP + ['/actiontracker/all-action-details/'+Value+';processId='+Id], '_self');
    }
   
  }

  callbackMethodForUnitDetails(response) {
    this.baseService.setItemInSession('obs_Units', JSON.stringify(response.Result));
    this.login = new Login();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: {
        GetActiveNodes: true,
        UserId: this.loggedInUserJSON.UserId
      }
    }
    this.masterscreenService.getTreeData(apiRequest, this.callbackMethodForGetTreeData.bind(this));

  }
  callbackMethodForGetTreeData(response) {
     
    this.baseService.setItemInSession('unitTree', JSON.stringify(response.Result));
    this.unitsProcessed = 0;
    this.units = [];
    if(response.Result!=null)
    {
    response.Result.forEach(element => {
      this.iterateTree(element);
    });
  }
    if (this.units.length > 0) {
      this.login.UnitId = this.units[this.unitsProcessed];
      const apiRequest = {
        Model: this.login
      };
      this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
    }
    this.observationService.getUserTypes(this.callbackMethodForgetUserTypes.bind(this));
  }
  processLocation(unitId) {
    this.login.UnitId = unitId;
    const apiRequest = {
      Model: this.login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
  }
  iterateTree(node) {
    this.login.UnitId = node.UnitId;
    this.units.push(node.UnitId);
    if (node.children && node.children.length > 0) {
      node.children.forEach(element => {
        if (element.children && element.children.length > 0) {
          this.iterateTree(element);
        }
      });
    }
  }
  callbackMethodForGetLocationData(response) {
    if (response && response.Result) {
      this.baseService.setItemInSession('locations_' + this.units[this.unitsProcessed], JSON.stringify(response.Result));
    }
    this.unitsProcessed++;
    if (this.unitsProcessed < this.units.length) {
      this.processLocation(this.units[this.unitsProcessed]);
    }
  }
  callbackMethodForgetUserTypes(response) {
    this.baseService.setItemInSession('userTypes', JSON.stringify(response.Result));
    this.masterscreenService.getAllModules(null, this.callbackMethodForGetAllModules.bind(this));
    const apiRequest = {
      Model: {
        CompanyId: 1
      }
    };
    this.observationService.getHazardTypeByCompanyId(apiRequest, this.callbackMethodForGetHazardTypeDetails.bind(this));
  }
  callbackMethodForGetAllModules(response) {
    this.baseService.setItemInSession('modules', JSON.stringify(response.Result));
  }
  callbackMethodForGetHazardTypeDetails(response) {
    this.baseService.setItemInSession('hazards', JSON.stringify(response.Result));
    const apiRequest1 = {
      Model: this.login
    };
    this.observationService.getCompanyData(apiRequest1, this.callbackMethodForgetCompanyData.bind(this));
  }
  callbackMethodForgetCompanyData(response) {
    this.baseService.setItemInSession("company", JSON.stringify(response.Result));
    const apiRequest2 = {
      Model: {
        'companyId': this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.observationService.getObservationTypeByCompanyId(apiRequest2, this.callbackMethodForGetObservationTypeDetails.bind(this));
  }
  callbackMethodForGetObservationTypeDetails(response) {
    this.baseService.setItemInSession("obsTypes", JSON.stringify(response.Result));
    this.observationService.getProcess(this.callbackMethodForgetProcess.bind(this));
  }
  callbackMethodForgetProcess(response) {
    const processList = response.Result;
    this.baseService.setItemInSession("processList", JSON.stringify(response.Result));
    processList.forEach(process => {
      if (process.ProcessName === 'Observation') {
        this.getStatusByProcessId(process.ProcessId);
      }
    });
  }
  getStatusByProcessId(processId) {
    const apiRequest = {
      Model: {
        ProcessId: processId
      }
    };
    this.observationService.getStatusByProcessId(apiRequest, this.callbackMethodForgetStatus.bind(this));
  }
  callbackMethodForgetStatus(response) {
    this.baseService.setItemInSession("obsStatus", JSON.stringify(response.Result));
    const login = new Login();
    login.CompanyId = 0;
    const apiRequest = {
      Model: login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForAllLocationData.bind(this));
  }
  callbackMethodForAllLocationData(response) {
    this.baseService.setItemInSession("allLocations", JSON.stringify(response.Result));
  }
  checkOnlineStatus() {
    const repeatCheck = interval(1000);
    repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
      }
      else {
        this.isOnline = false;
      }
    });
  }
  setUserDetails() {
    const loggedInUser = this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser);
    this.loggedInUserJSON = JSON.parse(loggedInUser);

    if (this.loggedInUserJSON.UserId) {
      this.isValidUser = true;
      this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
      let UserLogInInformationId = this.baseService.getItemFromSession('UserLogInInformationId');
      const savedIP = this.baseService.getItemFromSession('ipAddress');
      this.IpAddress = savedIP;

      if (UserLogInInformationId === null) {
        this.userloginid = 0;
      } else {
        this.userloginid = parseInt(UserLogInInformationId);
      }

      if (this.loggedInUserJSON !== null && UserLogInInformationId === null) {
        this.commonService.saveUserLogInInfo(this.loginDate, null, this.loggedInUserJSON.UserId, this.userloginid, this.IpAddress)
      }
      const permissionsFromSession = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
      if (permissionsFromSession) {
        this.permissions = permissionsFromSession;
      }
    } else {
      this.isValidUser = false;
    }
    this.baseService.setItemInSession('observationIds', null);
    this.baseService.setItemInSession('incidentIds', null);
    this.baseService.setItemInSession('riskIds', null);
    this.baseService.setItemInSession('actionIds', null);
    this.baseService.setItemInSession('pobRequests', null);
    this.baseService.setItemInSession('passRequests', null);
    this.baseService.setItemInSession('inspectionIds', null);
    this.baseService.setItemInSession('taskIds', null);
    this.baseService.setItemInSession('PTWIds', null);
    this.baseService.setItemInSession('TnCIds', null);
    this.baseService.setItemInSession('StatisticIds', null);
    this.baseService.setItemInSession('riskIds',null);

  }

  getFormattedDateWithOffset(date)
  {
    var diffinMin=date.getTimezoneOffset()*-1;
    date.setMinutes(date.getMinutes() + diffinMin);
    var dd   = date.getUTCDate();
    var mm   = date.getUTCMonth()+1;
    var yyyy = date.getUTCFullYear();
    var hour = date.getUTCHours();
    var minu = date.getUTCMinutes();

    if(dd<10)  { dd='0'+dd } 
    if(mm<10)  { mm='0'+mm } 
    if(minu<10){ minu='0'+minu } 

    return (yyyy == '0001' ? '' : dd +'/'+mm+'/'+yyyy);
  }

  getFormattedDateWithoutOffset(date)
  {
    var dd   = date.getDate();
    var mm   = date.getMonth()+1;
    var yyyy = date.getFullYear();
    var hour = date.getHours();
    var minu = date.getMinutes();

    if(dd<10)  { dd='0'+dd } 
    if(mm<10)  { mm='0'+mm } 
    if(minu<10){ minu='0'+minu } 

    return (yyyy == '0001' ? '' : dd +'/'+mm+'/'+yyyy);//+' '+hour+':'+minu);
  }


}
